export class BaseSidebar {
  moduleUid = 'base';
  show = false;
  elements = [];
}
